import { gql } from '@apollo/client';

export const UPDATE_ORDER_SHIPMENT_MUTATION = gql`
  mutation UpdateOrderShipmentBooking($input: UpdateOrderShipmentInput!) {
    updateOrderShipment(input: $input) {
      id
      orderId
      carrier
      packageType
      weight
      dimensions
      estimatedArrivalDate
      updatedAt
    }
  }
`;

export interface UpdateOrderShipmentInput {
  orderShipmentId: number;
  carrier?: string;
  packageType?: string;
  weight?: number;
  dimensions?: string;
  estimatedArrivalDate?: string;
}

export interface UpdateOrderShipmentResponse {
  id: number;
  orderId?: number;
  carrier?: string;
  packageType?: string;
  weight?: number;
  dimensions?: string;
  estimatedArrivalDate?: string;
  updatedAt?: string;
}

export interface UpdateOrderShipmentData {
  updateOrderShipment: UpdateOrderShipmentResponse;
}

export interface UpdateOrderShipmentVariables {
  input: UpdateOrderShipmentInput;
}
